import React from "react";
import PropTypes from "prop-types";

import Content from "./Content";

const BulletSection = ({ bullets, sectionHeading, className }) => {
    return (
        <div className={className}>
            <Content sectionHeading={sectionHeading} bullets={bullets} />
        </div>
    );
};

BulletSection.propTypes = {
    bullets: PropTypes.array.isRequired,
    sectionHeading: PropTypes.string,
    className: PropTypes.string
};

export { BulletSection };
